export const TIMELINE_FILTER_LOADING = "TIMELINE_FILTER_LOADING";
export const TIMELINE_FILTER_SUCCESS = "TIMELINE_FILTER__SUCCESS";
export const TIMELINE_FILTER_FAILED = "TIMELINE_FILTER__FAILED";
export const TIMELINE_FILTER_ADD = "TIMELINE_FILTER_ADD";
export const TIMELINE_VIEW_PERSIST = "TIMELINE_VIEW_PERSIST";
export const AUTOMATION_LOGS_FILTER_ADD = "AUTOMATION_LOGS_FILTER_ADD";
export const TIMELINE_FILTER_CLEAR = "TIMELINE_FILTER_CLEAR";
export const AUTOMATION_LOGS_FILTER_LOADING = "AUTOMATION_LOGS_FILTER_LOADING";
export const AUTOMATION_LOGS_FILTER_SUCCESS = "AUTOMATION_LOGS_FILTER_SUCCESS";
export const AUTOMATION_LOGS_FILTER_FAILED = "AUTOMATION_LOGS_FILTER_FAILED";
export const AUTOMATION_LOGS_FILTER_CLEAR = "AUTOMATION_LOGS_FILTER_CLEAR";
export const ANALYTICS_LOGS_FILTER_ADD = "ANALYTICS_LOGS_FILTER_ADD";
export const ANALYTICS_LOGS_FILTER_CLEAR = "ANALYTICS_LOGS_FILTER_CLEAR";
export const ANALYTICS_VIEW_PERSIST = "ANALYTICS_VIEW_PERSIST";
export const PAGE_REMEMBER_ADD = "PAGE_REMEMBER_ADD";
export const PAGE_REMEMBER_CLEAR = "PAGE_REMEMBER_CLEAR";
export const SET_CURRENT_SELECTED_BUILD = "SET_CURRENT_SELECTED_BUILD";
export const SET_CURRENT_SELECTED_TEST = "SET_CURRENT_SELECTED_TEST";
export const SET_CURRENT_SELECTED_TEST_LIST = "SET_CURRENT_SELECTED_TEST_LIST";
export const RESET_CURRENT_SELECTED_TEST = "RESET_CURRENT_SELECTED_TEST";
export const SWITCH_DRAWER_STATE = "SWITCH_DRAWER_STATE";
export const SWITCH_FILTER_FLAKY_TESTS = "SWITCH_FILTER_FLAKY_TESTS";
export const SWITCH_BROWSE_OR_FLAKY_TEST_DRAWER =
  "SWITCH_BROWSE_OR_FLAKY_TEST_DRAWER";
export const TEST_TIMELINE_FILTER_ADD = "TEST_TIMELINE_FILTER_ADD";
export const TEST_TIMELINE_FILTER_CLEAR = "TEST_TIMELINE_FILTER_CLEAR";
export const SET_TEST_SIDEBAR = "SET_TEST_SIDEBAR";
